import React, { useContext, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { Menu, SubMenu, Row, Col, Icon } from "./UIComponents";
import { UserContext } from "../context/UserContext";
import _ from 'lodash';
import { renderBadge, renderIcon } from "./Common";
import { OrgContext } from "../context/OrgContext";
import { downloadConsolidatedBols } from "../api/OrdersApi";
import { AgentNonRoutes } from "../config/Routes";
import { isDrayageEnabled } from "../DrayageRouteGuard";

export function renderSuperAdminMenuItems(item) {
  const isCustomIcon = /\.(png|jpg|jpeg|gif|svg)$/i.test(item.icon);
  function renderMenuItem() {
    return (
      <Menu.Item key={item.key}>
        <NavLink to={item.link}>
          {renderIcon(isCustomIcon, item)}
          <span className={item.className}>{item.text}</span>
        </NavLink>
      </Menu.Item>
    );
  }

  function renderSubMenu() {
    return (
      <SubMenu
        key={item.key}
        title={
          <span>
            {renderIcon(isCustomIcon, item)}
            <span className={item.className}>{item.text}</span>
          </span>
        }
      >
        {item.subMenuItems.map(renderSuperAdminMenuItems)}
      </SubMenu>
    );
  }

  return item.subMenuItems ? renderSubMenu() : renderMenuItem();
}

export function renderAdminMenuItems(items, history, renderBanner = () => {}) {
  const { rbacs, orgRules, currentRole,currentOrg } = useContext(UserContext);
  const {orgSettings} = useContext(OrgContext);
// const {
//   isDeclared,
//   isHazmat,
//   pendingOrders_count,

// } = useContext(ApprovalsOrderContext);
const isDeclared = orgSettings.isDeclared;
const isHazmat = orgSettings.isHazmat;
const pendingOrders_count = orgSettings.pendingOrders_count;


const ApprovalAccess = isDeclared || isHazmat;

  const DocumentsAccess = orgSettings?.show_documents_menu == "true"

// const ApprovalAccess = isDeclared || isHazmat;
    
  const isCustomIcon = /\.(png|jpg|jpeg|gif|svg)$/i.test(items.icon);
  // const MonthlyCutOff = ["LYKES", "QA", "FLTENBL", "DEMO","FET","KENCO"];
  const MonthlyCutOff = orgSettings &&  _.get(orgSettings, "monthly_cutoff","false");
  const viewDockScan = [ "ACTFT", "DEMO", "FLTENBL", "AVI" ];
  const viewFusionReport = orgSettings &&  _.get(orgSettings, "invoice_fusion_report","false");
  const viewSalesPersonReport = orgSettings && _.get(orgSettings, "sales_person_report", "false");
  const viewExternalBillingReport = orgSettings && _.get(orgSettings, "external_billing_report", "true");
  const viewStatusReport = orgSettings && _.get(orgSettings, "invoice_status_report","false");
  const viewInsightsMenu = orgSettings && _.get(orgSettings, "require_insights","false");
  const viewAIConverseMenu = ['QA', 'TESTQA', 'DEMO'].includes(currentOrg.code);
  const viewLinehaulMenu = orgSettings && _.get(orgSettings, "enable_linehaul_plus","false");
  const incomingOrgCode = _.get(currentOrg, "code");
  const creditLimitVal =
    orgRules && _.get(orgRules, "org_billing_rules.credit_limit_validation");
  const hasAccess =
    _.isEmpty(rbacs) ||
    _.some(_.get(items, "accessCodes", []), (code) => _.includes(rbacs, code));
  const navigateAccess = items.pathAccessCodes
    ? _.every(_.get(items, "pathAccessCodes", []), (code) =>
        _.includes(rbacs, code)
      )
    : _.every(_.get(items, "accessCodes", []), (code) =>
        _.includes(rbacs, code)
      ); 
   const isAgent=currentOrg?.fleet_lite=="true" || false;
   const isAgentMenu = !(AgentNonRoutes.map((item) => item.path).includes(items.key));
  // if (items.key === "insights_menu" && viewInsightsMenu !== "true") {
  //   return null;
  // }

  // Check if Drayage module is disabled
  if (items.key === "drayage_menu" && !isDrayageEnabled(orgSettings)) {
    return null;
  }

  if (items.key === "/dashboard" && currentRole === "sbadmin") {
    return null;
  }

  if(items.key === "ai_converse" && !viewAIConverseMenu){
    return null
  }
  if(items.key === "/line-haul" && viewLinehaulMenu !== "true"){
    return null
  }

  if(items.key === "/agent_tender_board" && _.get(orgSettings, "agent_load_tender", "false") !== "true"){
    return null
  }

  if(items.key === "/OrderApprovalList" && !ApprovalAccess){
    return null
  }

  if(items.key === "/documents" && !DocumentsAccess){
    return null
  }

  const hasRequiredAccessCodes = (item) => {
    if (_.isEmpty(rbacs)) return true;
    const codes = _.get(item, "accessCodes", []);
    if (_.isEmpty(codes)) return false;
    return _.every(codes, (code) => _.includes(rbacs, code));
  };

  const isHiddenByFeatureFlag = (item) => {
    if (item.key === "drayage_menu" && !isDrayageEnabled(orgSettings)) return true;
    if (item.key === "/dashboard" && currentRole === "sbadmin") return true;
    if (item.key === "ai_converse" && !viewAIConverseMenu) return true;
    if (item.key === "/line-haul" && viewLinehaulMenu !== "true") return true;
    if (item.key === "/OrderApprovalList" && !ApprovalAccess) return true;
    if (item.key === "/documents" && !DocumentsAccess) return true;
    return false;
  };

  if (items.subMenuItems && hasAccess) {
    let accessibleSubItems = items.subMenuItems.filter(
      (subItem) => hasRequiredAccessCodes(subItem) && !isHiddenByFeatureFlag(subItem)
    );

     // remove the preplan beta for other orgs except NETMOVE in aceessibleSubItems
    //  accessibleSubItems = accessibleSubItems.filter(
    //   (subItem) => subItem.key == "/preplan_management_beta" ? viewPreplanBeta.includes(incomingOrgCode) : true
    // );
    //remove the invoice fusion and invoice status according to org settings
    if (items.key === "report_menu") {
      const reports = [
        { viewStatus: viewFusionReport, key: "/qb_report" },
        { viewStatus: viewStatusReport, key: "/invoice_status_report" },
        { viewStatus: viewSalesPersonReport, key:"/sales_person_report"}
      ];

      reports.forEach(report => {
        if (report.viewStatus === "false") {
          accessibleSubItems = accessibleSubItems.filter(
            (subItem) => subItem.key !== report.key
          );
        }
      });
    }

    if(items.key === "order_management_menu" && viewLinehaulMenu === "true"){
      accessibleSubItems = accessibleSubItems.filter(
        (subItem) => subItem.key !== "/linehaul"
      );
    }
    //removing the dock scan report for other orgs except ACTFT

    if (items.key === "dock_scan_menu" && !viewDockScan.includes(incomingOrgCode)) {
      return null;
     }

    // If the key is 'billing_management_menu' and 'creditLimitVal' is 'false',
    // remove the submenu item with the key '/credit_limit'
    if (items.key === "billing_management_menu" && creditLimitVal === "false") {
      accessibleSubItems = accessibleSubItems.filter(
        (subItem) => subItem.key !== "/credit_limit"
      );
    }

    // If the key is 'billing_management_menu' and 'creditLimitVal' is 'false' and there are no accessible subItems,
    if (
      items.key === "billing_management_menu" &&
      creditLimitVal === "false" &&
      accessibleSubItems.length === 0
    ) {
      return null;
    }

    // if the key is 'billing_management_menu' and 'MonthlyCutOff' is not matching the incomingOrgCode,
    // remove the submenu item with the key '/monthly_cut_off'
    if (items.key === "billing_management_menu" && MonthlyCutOff === "false") {
      accessibleSubItems = accessibleSubItems.filter(
        (subItem) => subItem.key !== "/monthly_cutoff"
      );
    }

    if (items.key === "billing_management_menu" && viewExternalBillingReport === "false") {
      accessibleSubItems = accessibleSubItems.filter(
        (subItem) => subItem.key !== "/external_billing"
      );
    }

    if (items.key === "org_configuration") {
      if(currentRole === "sbadmin"){
        return null
      }
      if (viewSalesPersonReport === "false") {
        accessibleSubItems = accessibleSubItems.filter(
          (subItem) => subItem.key !== "/sales_person"
        );
      }
      // Check if there are accessible subItems other than 'roles'
      const hasOtherSubItems = accessibleSubItems.some(
        (subItem) => subItem.key !== "/roles"
      );
      // If there are no accessible subItems other than 'roles', don't render 'org_configuration'
      if (!hasOtherSubItems) {
        return null;
      }
    }

    if (accessibleSubItems.length === 0) {
      return null;
    }

    return (
      <SubMenu
        key={items.key}
        title={
            <span
            onClick={() => {
              if (_.isEmpty(rbacs) || navigateAccess) {
                history.push(items.path);
              }
            }}
          >
            <Row type="flex">
              <Col>
                {renderIcon(isCustomIcon, items, pendingOrders_count > 0)}
              </Col>
              {/* <Col>
                <span className={items.className}>{items.text}</span>
              </Col> */}
              <Col>{renderBadge(items, pendingOrders_count)}</Col>
            </Row>
          </span>
        }
      >
        {accessibleSubItems.map((item) => renderAdminMenuItems(item, history))}
      </SubMenu>
    );
  } else if (items.key === "org_configuration" && !hasAccess) {
    return null;
  } else if (
    items.key === "/roles"
      ? hasAccess && currentRole === items.RoleAccess
      : hasAccess
  ) {
    return (
      <Menu.Item key={items.key}>
        {items.link ? (
          <NavLink
            to={items.link}
            onClick={() => {
              if (typeof items.onClick === "function") {
                items.onClick();
              }
            }}
          >
            <Row type="flex">
              <Col>
                {renderIcon(isCustomIcon, items, pendingOrders_count > 0)}
              </Col>
              {/* <Col>
                <span className={items.className}>{items.text}</span>
              </Col> */}
              <Col>{renderBadge(items, pendingOrders_count)}</Col>
              {(isAgent && !isAgentMenu ) && <Icon style={{ color: "#FFC107", fontSize: "22px" }} type="crown" theme="filled" />}
            </Row>
          </NavLink>
        ) : (
          <div
            onClick={() => {
              items.key === "whats_new" ? renderBanner () : items.onClick();
            }}
          >
            <Row type="flex">
              <Col>
                {renderIcon(isCustomIcon, items, pendingOrders_count > 0)}
              </Col>
              {/* <Col>
                <span className={items.className}>{items.text}</span>
              </Col> */}
              <Col>{renderBadge(items, pendingOrders_count)}</Col>
            </Row>
          </div>
        )}
      </Menu.Item>
    );
  }
  return null;
}
